export const TIPOS_ARQUIVOS = {
  ANALISE: "ANALISE",
  APROVADO: "APROVADO",
  REPROVADO: "REPROVADO",
  UPLOAD: "UPLOAD",
  CANCELADO: "CANCELADO"
};
